import axios from 'axios';
import { getStoredToken } from './auth';

export const fetchData = async (request) => {
  const { method, endpoint, body, skipAuth } = request;
  const sessiontoken = getStoredToken();
  const requestModel = {
    method,
    url: endpoint,
    data: body
  };
  // Third-party hosts that need no auth must not receive the user's session token.
  if (sessiontoken && !skipAuth)
    requestModel.headers = {
      sessiontoken: sessiontoken
    };
  try {
    const response = await axios.request(requestModel);
    return response.data;
  } catch (e) {
    return {
      status: e.response?.status,
      data: e.response?.data
    }
  }
};
